<template>
  <div class="coming-soon">
    {{ $t('coming-soon.text') }}
  </div>
</template>

<script>
export default {
  name: 'ComingSoon',
}
</script>

<style lang="scss" scoped>
.coming-soon {
  padding: 20px;
  text-align: center;
  color: #67768a;
  opacity: 0.7;
  font-size: 28px;
}
</style>
